import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import { useNavigate } from "react-router-dom";
import { fetchPayment, setAmount } from '../slices/payment.slice';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { removeComma, separateNumber } from '../helpers/mmg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ErrorIcon from '@mui/icons-material/Error';
import queryString from 'query-string';

export const zeroPad = (num, places) => String(num).padStart(places, '0');

const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const Payment = () => {


  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))
  const payment = useSelector(x => x.payment);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));
  let navigate = useNavigate();



  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");



   useEffect(() => {
    if(parseFloat(removeComma(defaultValues.CustomerSaleAndFinancialDataModel.a8)) > 0){
      dispatch(setAmount(removeComma(defaultValues.CustomerSaleAndFinancialDataModel.a8)));
    }
    
      //dispatch(clearSelectedInvoice());
      //dispatch(fetchInvoice({saleDocId: entityId, saleDocType : 2 , authUser}));
      
     // getPaymentTestURL
    

   }, []);



   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
});


const onBackClicked = (e) =>{

  navigate('/invoices');

}


const handleChange = (e) =>{

  //console.log(encode(e.target.value));

  dispatch(setAmount(removeComma(e.target.value)));

}

const handleClick = (e) =>{

  e.preventDefault();
  if(parseInt(removeComma(payment.amount))){
    const rndInt = Math.floor(Math.random() * 6000) + 1000
    dispatch(fetchPayment({orderId: rndInt, amount : parseInt(removeComma(payment.amount)) , authUser}));
  }

}

return (
    <>

<ThemeProvider theme={mdTheme}>
<br/><br/><br/><br/><br/><br/>
  <Box sx={{ flexGrow: 1 }}>
  <Grid container
    justify="center"
    style={{ minHeight: '100vh' }}>
              <Grid item xs={12}>           
 {payment.loading ?   <Backdrop 
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>  : "" }
        <Card sx={{ minWidth: 275 }}>
      <CardContent
       style={{textAlign: 'center'}}
      >
        <Typography variant="h6" component="div">
        <AttachMoneyIcon sx={{ color: "#3F51B5" }} />    از طریق فرم زیر می توانید به صورت آنلاین اقدام به پرداخت مبلغ و کاهش مانده حساب نمایید
        </Typography>
        <hr/>
        <br/>
       
      <TextField
          id="outlined-helperText"
          label="مبلغ"
        
          value={payment.amount}
          //defaultValue="0"
          helperText={payment.amountInWord}
          onChange={handleChange}
        />
      {payment.error ? 
      <Typography component="div" sx={{ color: "#E53935" }}>
        <ErrorIcon sx={{ color: "#E53935" }} />خطا در ارسال درخواست &nbsp; {payment.errorMessage}
        </Typography>  : "" }
      </CardContent>
      <Box textAlign='center'>
      <Button variant="outlined" href="#outlined-buttons" onClick={handleClick}>
        ارسال به درگاه پرداخت
      </Button>
      </Box>

    </Card>
        
</Grid>
</Grid>
    </Box>
    </ThemeProvider>
    </>
  );
}

export default Payment;